module.exports = __webpack_public_path__ + "img/IN6×6-Silk-Mono-Wefted-Back-Clip-on-Hair-Topper-3.c0bd31c4.jpg";